import { RouteRecordRaw } from 'vue-router'

const auditsRoutes: RouteRecordRaw[] = [
  {
    path: '/audits',
    name: 'audits.index',
    component: () => import('@/modules/operations/views/Audits/AuditsIndex.vue'),
    meta: {
      pageTitle: 'Audits',
      breadcrumbs: ['Audits']
    }
  },
  {
    path: '/audits/:id/show',
    name: 'audits.show',
    component: () => import('@/modules/operations/views/Audits/AuditsShow.vue'),
    meta: {
      pageTitle: 'Show Audit',
      breadcrumbs: ['Audits']
    }
  }
]

export default auditsRoutes
